<template>
  <section class="official-header">
    <img src="../assets/image/bg.png" class="official-header-nav-image">
    <div class="official-header-content">
      <div class="official-nav-content-left">
        <img class="official-header-nav-lefticon" src="../assets/image/square.png">
        <img class="official-nav-logo" src="../assets/image/logodt-1.png">
        <!-- <span class="official-topWords">弘扬地方文化，享受移动生活</span> -->
        <img src="../assets/image/topleftWords.png" class="official-topWords">
      </div>
      <div class="official-nav-content-right">
        <img src="../assets/image/square.png" class="official-header-nav-righticon">
        <div class="official-nav-content">
          <a href="https://www.bianfeng.com/" target="_blank"
            class="official-nav-content-item official-content-about"></a>
          <div @click="scrollToView('server-containner')"
            class="official-nav-content-item official-content-service"></div>
          <div @click="scrollToView('game-containner')"
            class="official-nav-content-item official-content-feature"></div>
          <div @click="scrollToView('download-containner')"
            class="official-nav-content-item official-content-download"></div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import scrollToTop from 'src/utils/assist.js';
export default {
  methods: {
    scrollToView (type) {
      this.$nextTick(() => {
        let el = document.getElementById(type);
        let elScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        scrollToTop(window, elScrollTop, el.offsetTop - 100, 1000);
      });
    }
  }
};
</script>
